import Header from './components/Header';
import Hero from './components/Hero';
import Comments from './components/Comments';
import IndexSection from './components/IndexSection';
import FAQ from './components/FAQ';
import About from './components/About';
import Media from './components/Media';
import Updates from './components/Updates';
import Topics from './components/Topics';
import Features from './components/Features';
import AppDownload from './components/AppDownload';
import Contact from './components/Contact';
import CarouselSection from './components/CarouselSection';
import Ranking from './components/Ranking';
import Cards from './components/Cards';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Comments />
        <IndexSection />
        <FAQ />
        <About />
        <Media />
        <Updates />
        <Topics />
        <Features />
        <AppDownload />
        <Contact />
        <CarouselSection />
        <Ranking />
        <Cards />
      </main>
      <Footer />
    </>
  );
}